export default __webpack_public_path__ + "static/media/instruction-title-3.2a9a0c59.png";